var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.324,
    height: 10.477,
    viewBox: "0 0 2.324 10.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#748b94}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_more_4070889_000000",
    transform: "translate(46.683 -24.579) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    d: "M25.741 44.359a1.162 1.162 0 1 0 .822.34 1.163 1.163 0 0 0-.822-.34z",
    className: "cls-1",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    d: "M46.684 45.522a1.162 1.162 0 1 1-1.162-1.162 1.163 1.163 0 0 1 1.162 1.162",
    className: "cls-1",
    transform: "translate(-15.705 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    d: "M65.31 44.359a1.162 1.162 0 1 0 .823.34 1.162 1.162 0 0 0-.823-.34z",
    className: "cls-1",
    transform: "translate(-31.418)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.a3a053a63b4a5b947483dad0dff9e066.svg";
export { ForwardRef as ReactComponent };